/* eslint-disable max-len */
import {
    RootState,
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import {
    BTX_SPECIAL_CASES,
    CONTAINER_LOADING_SPINNER,
    NAMESPACE,
} from './constant';
import { createStructuredSelector } from 'reselect';
import {
    selectComponents,
    selectError,
    selectIsUserLoggedIn,
    selectLoading,
    selectMtanStep,
} from './selector';
import reducer from './reducer';
import { authenticationSaga } from './saga';
import {
    actionDispatchers,
    AppActionDispatchers,
} from './action';
import './style.scss';
import {
    EndpointType,
    IAuthentication,
} from './interfaces/main.interface';
import { manageSteps } from './helper/manageSteps.helper';
import { handleError } from './helper/errorHandler.helper';
import { getCurrentBtx } from './helper/getUrlParams.helper';
import { mountLoadingSpinner } from '../../components/loadingSpinner.component';
import { redirectToEndpoint } from './helper/endpointHandler.helper';

/**
 * Authentication function
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function Authentication (state: IAuthentication, action: AppActionDispatchers) {
    injectReducer(NAMESPACE, reducer);
    injectSaga(NAMESPACE, authenticationSaga);

    const btx = getCurrentBtx();
    const loadingSpinnerComponent = mountLoadingSpinner(CONTAINER_LOADING_SPINNER);
    const ecNeeded = BTX_SPECIAL_CASES.includes(btx);

    action.initPage(btx, action);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         */
        getDerivedStateFromProps (newState: IAuthentication, oldState: IAuthentication) {
            if (oldState.loading !== newState.loading) {
                loadingSpinnerComponent?.toggle();
            }

            if (oldState.isUserLoggedIn !== newState.isUserLoggedIn && newState.isUserLoggedIn) {
                ecNeeded ? action.eligibilityCheck(btx, 1) : redirectToEndpoint({ btx } as EndpointType);
            }

            if (oldState.mtanStep !== newState.mtanStep && newState.components) {
                manageSteps(newState.mtanStep!, btx, newState.components, action.setError);
            }

            if (oldState.error !== newState.error) {
                handleError(newState.error);
            }
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState<IAuthentication>, IAuthentication>({
    loading: selectLoading(),
    error: selectError(),
    mtanStep: selectMtanStep(),
    isUserLoggedIn: selectIsUserLoggedIn(),
    components: selectComponents(),
});

const authentication = connect(mapStateToProps, actionDispatchers)(Authentication);
export default authentication;
